var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useState, useEffect, useRef } from "react";
import { acceptNumberOnly, } from "@frameworks/web/components/features/TOC/constant";
import InputField from "@frameworks/web/components/generic/inputField";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/RedeemSIP/RedeemSIP.scss";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import { roundUpToThreeDecimalPlaces } from "@domains/utils/numberMethods";
import { RedeemCard } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/RedeemComp/RedeemCard";
import SipCalendar from "@frameworks/shared-library/components/TransactionJourney/MutualFund/CommonComp/SipCalendar";
import moment from "moment";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { floatNumExp } from "@frameworks/salesjourney/utils/regex";
import { checkMultiplier, EReedemType, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import FolioSelection from "@frameworks/shared-library/components/TransactionJourney/MutualFund/CommonComp/FolioSelection";
import { EHoldingType } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
var SWPMain = function (props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var swpContainerRef = useRef();
    var redeemDetailsRef = useRef();
    var _x = __read(useState(false), 2), schemeError = _x[0], setSchemeError = _x[1];
    var _y = __read(useState(Number((_a = props.redeemValObj) === null || _a === void 0 ? void 0 : _a.minInstAmt)), 2), minAmt = _y[0], setMinAmt = _y[1];
    //   // const [MfInvestment, setMfInvestment] = useState<IProdButton[]>();
    var sipFreq = useMemo(function () {
        var _a;
        var parseDate = function (dateStr) {
            return new Date(dateStr.split(" ").reverse().join(" "));
        };
        try {
            if (((_a = props.startDate) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var dateList_1 = __spreadArray([], __read(props.startDate), false).sort(function (a, b) {
                    return parseDate(a).getTime() - parseDate(b).getTime();
                });
                var z_1 = 0;
                return __spreadArray([], __read(Array(28)), false).map(function (_, i) {
                    var value = "";
                    if (dateList_1[z_1] && i + 1 === parseDate(dateList_1[z_1]).getDate()) {
                        value = dateList_1[z_1];
                        z_1++;
                    }
                    return { label: i + 1, value: value };
                });
            }
        }
        catch (e) {
            console.log(e);
        }
    }, [props.startDate]);
    var _z = __read(useState([]), 2), genericDetailsAccordianData = _z[0], setGenericDetailsAccordianData = _z[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // we can move this to RedeemCard component need to check
        if (props.folio) {
            var genericDetailsAccordianData_1 = [
                {
                    label: "Long term units",
                    value: "".concat((_a = props.folio) === null || _a === void 0 ? void 0 : _a.longTermQty, "(Approx)/ \u20B9").concat(roundUpToThreeDecimalPlaces(+((_b = props.folio) === null || _b === void 0 ? void 0 : _b.longTermQty) * +((_c = props.folio) === null || _c === void 0 ? void 0 : _c.nav)), " "),
                },
                {
                    label: "Short term units",
                    value: "".concat((_d = props.folio) === null || _d === void 0 ? void 0 : _d.shortTermQty, "(Approx)/\u20B9").concat(roundUpToThreeDecimalPlaces(+((_e = props.folio) === null || _e === void 0 ? void 0 : _e.shortTermQty) * +((_f = props.folio) === null || _f === void 0 ? void 0 : _f.nav))),
                },
                {
                    label: "Process Time",
                    value: (_g = props.folio) === null || _g === void 0 ? void 0 : _g.redemptionTime,
                },
                {
                    label: "Current NAV",
                    value: (_h = props.folio) === null || _h === void 0 ? void 0 : _h.nav,
                    valueType: EValueType.CURRENCY,
                },
                {
                    label: (React.createElement("span", null,
                        React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "These are mutual fund units that can be redeemed or sold without any restrictions, such as lock-in periods or exit loads." }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info swp-tooltip-info", noButton: true, button: React.createElement("span", { className: "d-flex align-items-center gap-1" },
                                "Free Units",
                                React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block fs-15" })), tooltipRef: redeemDetailsRef }))),
                    value: ((_j = props === null || props === void 0 ? void 0 : props.folio) === null || _j === void 0 ? void 0 : _j.freeQty) || "-",
                },
            ];
            setGenericDetailsAccordianData(genericDetailsAccordianData_1);
        }
    }, [props.folio]);
    var getUnits = function (amt) {
        var _a;
        return roundUpToThreeDecimalPlaces(amt / +((_a = props.folio) === null || _a === void 0 ? void 0 : _a.nav));
    };
    var handleFolioSelection = function (data) {
        var _a, _b, _c, _d;
        var longTermData = {};
        var maxRedAmt = +((_a = props.redeemValObj) === null || _a === void 0 ? void 0 : _a.maxInstAmt) === 0
            ? (+(data === null || data === void 0 ? void 0 : data.totalQty) * +(data === null || data === void 0 ? void 0 : data.nav)).toString()
            : (_b = props.redeemValObj) === null || _b === void 0 ? void 0 : _b.maxInstAmt;
        if ((_c = props.purchaseFormData) === null || _c === void 0 ? void 0 : _c.isRedeemLongTerm) {
            longTermData = {
                amount: roundUpToThreeDecimalPlaces(+(data === null || data === void 0 ? void 0 : data.longTermQty) * +(data === null || data === void 0 ? void 0 : data.nav)),
                qty: data === null || data === void 0 ? void 0 : data.longTermQty,
            };
        }
        else {
            longTermData = {
                amount: (_d = props.purchaseFormData) === null || _d === void 0 ? void 0 : _d.amount,
                qty: data === null || data === void 0 ? void 0 : data.longTermQty,
            };
        }
        props.setPurchaseFormData(function (pData) {
            return __assign(__assign({}, pData), longTermData);
        });
        var highestRed = +maxRedAmt > +data.totalQty * +data.nav
            ? +data.totalQty * +data.nav
            : maxRedAmt;
        highestRed = roundUpToThreeDecimalPlaces(+highestRed);
        validateAmount(longTermData.amount, +highestRed);
        props.setPhysicalFlag(data.folioType === EReedemType.PHYSICAL
            ? EHoldingType.Physical
            : EHoldingType.Demat);
        props.setFolio(data);
    };
    var validateAmount = function (value, highestRed) {
        if (!value || (value && Number(value) <= 0)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Amount can not be blank or 0",
                } }));
        }
        else if (value && Number(value) < Number(minAmt)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Please ensure that the entered SWP amount is in the range  of  ".concat(minAmt, "  to ").concat(highestRed, " for ").concat(props.schemeName),
                } }));
            // } else if (
            //   value &&
            //   Number(value) > Number(highestRed) &&
            //   highestRed < Number(minAmt)
            // ) {
            //   props.setFormErrors({
            //     ...props.formErrors,
            //     amount: {
            //       status: true,
            //       msg: `Available balance in the selected folio is less than the min amount allowed for SWP of  ${minAmt}`,
            //     },
            //   });
        }
        else if (
        // for greater than max value
        value &&
            Number(value) > Number(highestRed)) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Please ensure that the entered SWP amount is in the range  of  ".concat(minAmt, "  to ").concat(highestRed, " for ").concat(props.schemeName),
                } }));
        }
        else if (value &&
            checkMultiplier(+value, +props.purchaseAmtMul)
        // Number(value) %
        //   (+props.purchaseAmtMul *
        //     +props?.redeemValObj?.minInstAmt) !==
        //   0
        ) {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: {
                    status: true,
                    msg: "Please ensure that the SWP amount is in multiples of ".concat(props === null || props === void 0 ? void 0 : props.purchaseAmtMul),
                } }));
        }
        else {
            props.setFormErrors(__assign(__assign({}, props.formErrors), { amount: { status: false, msg: "" } }));
        }
    };
    var updateErrorState = function (value, isChecked) {
        var _a;
        // const freeQtyValue = +props.folio.freeQty * +props.folio.nav;
        var marketValue = +props.folio.marketValue;
        var maxRedAmtProp = +((_a = props === null || props === void 0 ? void 0 : props.redeemValObj) === null || _a === void 0 ? void 0 : _a.maxInstAmt);
        var maxRedAmt = Number(maxRedAmtProp === 0 ? Math.min(marketValue) : Math.min(maxRedAmtProp));
        var maximumRedeemAbleAmount = roundUpToThreeDecimalPlaces(+maxRedAmt);
        if (isChecked) {
            props.setPurchaseFormData(function (pData) {
                var _a, _b;
                return __assign(__assign({}, pData), { amount: Math.min(+((_a = props.folio) === null || _a === void 0 ? void 0 : _a.longTermQty) * +((_b = props.folio) === null || _b === void 0 ? void 0 : _b.nav)), quantity: Math.min(+props.folio.longTermQty) });
            });
        }
        props.setPurchaseFormData(function (pData) {
            return __assign(__assign({}, pData), { amount: value, quantity: getUnits(+value) });
        });
        validateAmount(value, +maximumRedeemAbleAmount);
    };
    var commonSwpToolTip = function (tootlTipText, tooltipCustom, position) {
        if (position === void 0) { position = "bottom"; }
        return (React.createElement(GenericTooltip, { placement: position, toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: tootlTipText, tooltipCustom: tooltipCustom }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info mb-6 swp-tooltip-info", noButton: true, tooltipRef: swpContainerRef, button: React.createElement("span", { className: "edel-icon-Information txt_secondary-gray d-flex mb-1" }) }));
    };
    return (React.createElement(React.Fragment, null, !schemeError && (React.createElement("div", { className: "primary-side-txn-form-redeem-container position-relative", ref: swpContainerRef },
        React.createElement("div", { className: "upper-form-panel" },
            React.createElement("div", { className: "primary_sip_txn_container" },
                React.createElement("div", { className: "w-100 d-flex gap-1 align-items-center" },
                    React.createElement("span", { className: "DMSansNormal_20_400 d-flex gap-1" },
                        "SWP",
                        " ",
                        React.createElement("div", { className: "DMSans_13_400 mt-1" }, "(Systematic Withdrawal Plan)")),
                    commonSwpToolTip("A Systematic Withdrawal Plan (SWP) allows you to withdraw a fixed amount from your investment at regular intervals.")),
                ((_c = (_b = props === null || props === void 0 ? void 0 : props.mfHoldingDetail) === null || _b === void 0 ? void 0 : _b.clientHoldingDetails) === null || _c === void 0 ? void 0 : _c.length) > 0 && (React.createElement(React.Fragment, null,
                    ((_e = (_d = props === null || props === void 0 ? void 0 : props.mfHoldingDetail) === null || _d === void 0 ? void 0 : _d.clientHoldingDetails) === null || _e === void 0 ? void 0 : _e.length) > 1 && (React.createElement("div", { className: "DMSansNormal_12_400 bg-pale-lemon info-txt-block txt-grey-shade1" }, "Multiple folios detected. Please select a folio to redeem. Full redemption is required for multiple folios.")),
                    React.createElement(FolioSelection, { folioList: (_f = props === null || props === void 0 ? void 0 : props.mfHoldingDetail) === null || _f === void 0 ? void 0 : _f.clientHoldingDetails, folio: props === null || props === void 0 ? void 0 : props.folio, setFolio: handleFolioSelection, schemeName: props === null || props === void 0 ? void 0 : props.schemeName }))),
                React.createElement(RedeemCard, { amount: roundUpToThreeDecimalPlaces(+((_g = props === null || props === void 0 ? void 0 : props.folio) === null || _g === void 0 ? void 0 : _g.marketValue)), timestamp: (_h = props === null || props === void 0 ? void 0 : props.folio) === null || _h === void 0 ? void 0 : _h.dpNavDate, units: (_j = props === null || props === void 0 ? void 0 : props.folio) === null || _j === void 0 ? void 0 : _j.totalQty, genericDetailsAccordianData: genericDetailsAccordianData, leftTitle: "Available to Withdraw", tooltipRef: redeemDetailsRef }),
                React.createElement("div", { className: "mgt-20" },
                    React.createElement("div", { className: "w-100 d-flex flex-row gap-1 align-items-center" },
                        React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-4" }, "Monthly Withdrawal Amount"),
                        commonSwpToolTip("Select the date on which you want the withdrawal to be processed every month. Ensure sufficient balance in your account on the chosen date to avoid transaction failure.")),
                    React.createElement("div", null,
                        React.createElement(InputField, { autofocus: true, float: floatNumExp(3), disabled: (_k = props.purchaseFormData) === null || _k === void 0 ? void 0 : _k.isRedeemLongTerm, inputMode: "numeric", type: "number", placeholder: "Enter Amount", defaultValue: (_l = props.purchaseFormData) === null || _l === void 0 ? void 0 : _l.amount, value: (_m = props.purchaseFormData) === null || _m === void 0 ? void 0 : _m.amount, inputPattern: "[0-9]*", placeholderClassName: "amount", "box-disable": true, errorText: props.formErrors.amount.msg, passErrorTextButHideErrTxt: true, highlightInputField: true, className: "custom-box custom-box-relative ".concat(((_o = props.purchaseFormData) === null || _o === void 0 ? void 0 : _o.isRedeemLongTerm)
                                ? "box-disable"
                                : ""), onChange: function (value) {
                                if (/^0\d/.test(value)) {
                                    value = value.replace(/^0+/, "");
                                }
                                // props.setPurchaseFormData((pData: MFFormData) => {
                                //   return {
                                //     ...pData,
                                //     amount: Number(value),
                                //     quantity: getUnits(),
                                //   };
                                // });
                                updateErrorState(value);
                                // if (!value || (value && Number(value) <= 0)) {
                                //   props.setFormErrors({
                                //     ...props.formErrors,
                                //     amount: {
                                //       status: true,
                                //       msg: `Amount can not be blank or 0`,
                                //     },
                                //   });
                                // } else if (value && Number(value) < Number(minAmt)) {
                                //   props.setFormErrors({
                                //     ...props.formErrors,
                                //     amount: {
                                //       status: true,
                                //       msg: `Please ensure that the entered SWP amount is in the range  of  ${minAmt}  to ${props.redeemValObj?.maxInstAmt} for ${props.schemeName}`,
                                //     },
                                //   });
                                // } else if (
                                //   value &&
                                //   Number(value) > Number(props.redeemValObj?.maxInstAmt)
                                // ) {
                                //   props.setFormErrors({
                                //     ...props.formErrors,
                                //     amount: {
                                //       status: true,
                                //       msg: `Please ensure that the entered SWP amount is in the range  of  ${minAmt}  to ${props.redeemValObj?.maxInstAmt} for ${props.schemeName}`,
                                //     },
                                //   });
                                // } else if (
                                //   value &&
                                //   checkMultiplier(+value, +props.purchaseAmtMul)
                                //   // Number(value) %
                                //   //   (+props.purchaseAmtMul *
                                //   //     +props?.redeemValObj?.minInstAmt) !==
                                //   //   0
                                // ) {
                                //   props.setFormErrors({
                                //     ...props.formErrors,
                                //     amount: {
                                //       status: true,
                                //       msg: `Please ensure that the SWP amount is in multiples of ${props?.purchaseAmtMul}`,
                                //     },
                                //   });
                                // } else {
                                //   props.setFormErrors({
                                //     ...props.formErrors,
                                //     amount: { status: false, msg: `` },
                                //   });
                                // }
                            }, onKeyDown: function (e) {
                                if (acceptNumberOnly(e.key)) {
                                    e.preventDefault();
                                }
                            }, onWheel: function (e) {
                                return e.currentTarget.blur();
                            }, required: true },
                            React.createElement("div", { className: "rupee__icon position-absolute" },
                                React.createElement("span", null, "\u20B9")),
                            React.createElement("div", { className: "redeem-units-box justify-content-center flex-column align-items-start" },
                                React.createElement("span", null,
                                    "Units: ",
                                    getUnits(+((_p = props.purchaseFormData) === null || _p === void 0 ? void 0 : _p.amount))))),
                        props.formErrors.amount.status && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex pt-6" },
                            React.createElement("span", null, props.formErrors.amount.msg))),
                        React.createElement("span", { className: "DMSansNormal_12_400 text_box_bottom" },
                            "Min. \u20B9", (_q = props.redeemValObj) === null || _q === void 0 ? void 0 :
                            _q.minInstAmt))),
                React.createElement("div", { className: "mgt-20 swp-withdraw-date-container" },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-10" }, "Withdraw Amount On")),
                    React.createElement("span", null, ((_r = props.startDate) === null || _r === void 0 ? void 0 : _r.length) > 0 && (React.createElement(SipCalendar, { selectedVal: (_s = props.purchaseFormData) === null || _s === void 0 ? void 0 : _s.sipDate, setSelectedVal: function (value) {
                            props.setPurchaseFormData(function (pData) {
                                return __assign(__assign({}, pData), { sipDate: String(value.value), startDay: String(value.label), startDt: moment(String(value.value)).format("YYYY-MM-DD") });
                            });
                        }, dateList: sipFreq, suffixTextforSelectedValue: "of Every Month", closeOnOutSideClick: true, transactionType: "SWP" })))),
                React.createElement("div", { className: "mgt-20" },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("span", { className: "DMSans_13_400 txt_blackOne1 mgr-10" }, "Number of Withdrawals")),
                    React.createElement("div", null,
                        React.createElement(InputField, { autofocus: true, integer: true, inputMode: "numeric", type: "number", max: 999, placeholder: "Enter Installment", defaultValue: (_t = props.purchaseFormData) === null || _t === void 0 ? void 0 : _t.installmentCount, value: (_u = props.purchaseFormData) === null || _u === void 0 ? void 0 : _u.installmentCount, inputPattern: "[0-9]*", placeholderClassName: "amount", "box-disable": true, maxLength: 9, className: "custom-box custom-box-relative installment-box", errorText: props.formErrors.installmentCount.msg, passErrorTextButHideErrTxt: true, highlightInputField: true, onChange: function (value) {
                                var _a, _b, _c;
                                props.setPurchaseFormData(function (pData) {
                                    return __assign(__assign({}, pData), { installmentCount: Number(value) });
                                });
                                if (!value || (value && Number(value) <= 0)) {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { installmentCount: {
                                            status: true,
                                            msg: "Count can not be blank or 0",
                                        } }));
                                }
                                else if (value &&
                                    Number(value) < Number((_a = props.redeemValObj) === null || _a === void 0 ? void 0 : _a.minInstNum)) {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { installmentCount: {
                                            status: true,
                                            msg: "Please ensure that the continuity is greater than or equal to ".concat(props.redeemValObj.minInstNum, " months"),
                                        } }));
                                }
                                else if (value &&
                                    Number(value) > Number((_b = props.redeemValObj) === null || _b === void 0 ? void 0 : _b.maxInstNum)) {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { installmentCount: {
                                            status: true,
                                            msg: "Please ensure that the continuity is greater than or equal to ".concat((_c = props === null || props === void 0 ? void 0 : props.redeemValObj) === null || _c === void 0 ? void 0 : _c.maxInstNum, " months"),
                                        } }));
                                }
                                else {
                                    props.setFormErrors(__assign(__assign({}, props.formErrors), { installmentCount: { status: false, msg: "" } }));
                                }
                            }, onKeyDown: function (e) {
                                if (e.key === "." || acceptNumberOnly(e.key)) {
                                    e.preventDefault();
                                }
                            }, onWheel: function (e) {
                                return e.currentTarget.blur();
                            }, required: true }),
                        props.formErrors.installmentCount.status && (React.createElement("div", { className: "text-danger DMSansNormal_12_400 d-flex pt-6" },
                            React.createElement("span", null, props.formErrors.installmentCount.msg))),
                        React.createElement("span", { className: "DMSansNormal_12_400 text_box_bottom" },
                            "Min. ", (_v = props === null || props === void 0 ? void 0 : props.redeemValObj) === null || _v === void 0 ? void 0 :
                            _v.minInstNum))),
                React.createElement("div", { className: "redeem-section d-flex align-items-start mt-30" },
                    React.createElement(GenericCheckbox, { parentClassName: "individual-checkbox-wrapper", checkboxProps: {
                            onChange: function (e) {
                                var _a, _b;
                                var longTermData = {};
                                if (e.target.checked) {
                                    longTermData = {
                                        amount: roundUpToThreeDecimalPlaces(Math.min(+props.folio.longTermQty) *
                                            +((_a = props === null || props === void 0 ? void 0 : props.folio) === null || _a === void 0 ? void 0 : _a.nav)),
                                        // amount: roundUpToThreeDecimalPlaces(
                                        //   +props?.folio?.longTermQty * +props?.folio.nav
                                        // ),
                                        qty: Math.min(+props.folio.longTermQty).toString(),
                                    };
                                }
                                else {
                                    longTermData = {
                                        amount: (_b = props.purchaseFormData) === null || _b === void 0 ? void 0 : _b.amount,
                                    };
                                }
                                updateErrorState(longTermData.amount, e.target.checked);
                                props.setPurchaseFormData(function (pData) {
                                    return __assign(__assign(__assign({}, pData), { isRedeemLongTerm: e.target.checked }), longTermData);
                                });
                            },
                            id: "1",
                            checked: (_w = props.purchaseFormData) === null || _w === void 0 ? void 0 : _w.isRedeemLongTerm,
                            value: 11,
                            className: "m-0",
                        }, labelProps: {
                            htmlFor: "",
                            children: (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "d-flex align-items-center" }))),
                        }, checkboxType: "han-blue" }),
                    React.createElement("div", null,
                        React.createElement("span", { className: "DMSans_13_400 d-flex gap-2 align-items-baseline" },
                            "Withdraw Long-Term Units Only",
                            commonSwpToolTip("Withdraw investments held for over 1 year to benefit from long-term capital gain tax rates.", [
                                {
                                    name: "Note",
                                    description: " Exit load may still apply.",
                                },
                            ], "top")),
                        React.createElement("span", { className: "DMSansNormal_12_400 muted-text" }, "Helps you avoid exit loads and benefit from lower tax rates."))),
                React.createElement("div", { className: "mt-20 mb-20 horizontal-divider" })))))));
};
export default SWPMain;
